import { Badge, Box, Flex, Text } from '@chakra-ui/react';

import { Table } from '@morressier/alembic';

export interface ISpecialtyKeyword {
  specialtyName: string;
  keyword: string;
  subSpecialtyName?: string;
  scandinavianKeyword?: string;
}
export interface IResearchSpecialtyKeyword {
  specialtyAndKeywords: ISpecialtyKeyword[];
  reviewerInterest: string;
  unavailabilityPeriodFrom: string;
  unavailabilityPeriodTo: string;
  professionalInterests: string[];
}
type RenderResearchSpecialtyKeywordProps = {
  value: IResearchSpecialtyKeyword | undefined;
  label: string;
  badge: string;
};
export const handleOpenUrl = (url: string) => {
  const urlWithProtocol = url?.match(/^https?:\/\//) ? url : `https://${url}`;

  window.open(urlWithProtocol, '_blank', 'noopener,noreferrer');
};

export const RenderResearchSpecialtyKeyword = ({
  value,
  label,
  badge
}: RenderResearchSpecialtyKeywordProps) => {
  const { specialtyAndKeywords } = value ?? {};
  if (!specialtyAndKeywords?.length) return null;
  return (
    <>
      {' '}
      <Flex direction="column" gap={1}>
        <Text textStyle="headingItem" mb={2}>
          {label}{' '}
          <Badge
            size="context"
            variant={badge === 'Previous' ? 'neutral' : 'attention'}
          >
            {badge}
          </Badge>
        </Text>{' '}
        <Box
          backgroundColor="surfacePrimaryFill"
          borderWidth="1px"
          borderColor="neutralPrimaryBorder"
          borderRadius="8px"
          overflow="hidden"
        >
          <Box overflowX="auto" width="100%">
            <Table>
              <Table.HeaderRow>
                <Table.HeaderCell flex={1} textAlign="left">
                  Sr. No
                </Table.HeaderCell>
                <Table.HeaderCell flex={1} textAlign="left">
                  Specialty
                </Table.HeaderCell>
                <Table.HeaderCell flex={1} textAlign="left">
                  Sub-Specialty
                </Table.HeaderCell>
                <Table.HeaderCell flex={1} textAlign="left">
                  Keyword(s)
                </Table.HeaderCell>
                <Table.HeaderCell flex={1} textAlign="left">
                  Scandinavian Keyword(s)
                </Table.HeaderCell>
              </Table.HeaderRow>

              <Table.Body>
                {specialtyAndKeywords?.map((item, index) => (
                  <Table.Row key={index}>
                    <Table.RowCell flex={1} textAlign="left">
                      <Text>{index + 1}</Text>
                    </Table.RowCell>

                    <Table.RowCell flex={1} textAlign="left">
                      <Text>{item?.specialtyName || '-'}</Text>
                    </Table.RowCell>

                    <Table.RowCell flex={1} textAlign="left">
                      <Text>{item?.subSpecialtyName || '-'}</Text>
                    </Table.RowCell>

                    <Table.RowCell flex={1} textAlign="left">
                      <Text>{item?.keyword || '-'}</Text>
                    </Table.RowCell>

                    <Table.RowCell flex={1} textAlign="left">
                      <Text>{item?.scandinavianKeyword || '-'}</Text>
                    </Table.RowCell>
                  </Table.Row>
                ))}
              </Table.Body>
            </Table>
          </Box>
        </Box>
      </Flex>
    </>
  );
};
